// Structure du r�sultat d'un appel API

export interface IAPICallResult<T> {
	focus: string;		// Non utilis� ?
	url: string;		// Non utilis� ?
	status: CallStatusEnum;
	action: ActionEnum;
	messages: IServiceMessage[];
	sound: string;


	// Charge utile
	data: T;
}

export interface IServiceMessage {
	level: MessageLevelEnum;
    message: string;
}

export enum ActionEnum {
	None = 1,           // = RIEN
	Popup = 2,          // = Affichage Message Popup
	Sound = 3,          //  = Jouer un son
	PopupAndSOund = 4,  // = Affichage Popup + Son
}

export enum CallStatusEnum {
	Default = 0,
	Ok = 1,
	Information = 2,
	Warning = 3,
	Error = 4,
	Critical = 5,

	ServerHTTPOK = 200,

	ServerTempRedirect = 307,
	ServerUnauthorized = 401,
	ServerNotFound = 404,
	ServerGenericError = 500,
}

export enum MessageLevelEnum {
	Information = 1,
	Warning = 2,
	Error = 3,

	Critical = 5
}